import { ActionReducerMap } from '@ngrx/store';
import { routerReducer, RouterState } from '@ngrx/router-store';

import * as fromInit from './init';
import * as fromCompany from './company';
import * as fromGlobalError from './global-error';
import * as fromNotification from './notification';
import * as fromAuthorization from '@modules/authorization/store';

export interface AppState {
  company: fromCompany.CompanyState;
  globalError: fromGlobalError.GlobalErrorState;
  notification: fromNotification.NotificationState;
  router: RouterState;
}

export const reducer: ActionReducerMap<AppState> = {
  company: fromCompany.reducer,
  globalError: fromGlobalError.reducer,
  notification: fromNotification.reducer,
  router: routerReducer,
};

export const effects = [
  fromInit.InitEffects,
  fromCompany.CompanyEffects,
  fromGlobalError.GlobalErrorEffects,
  ...fromAuthorization.effects,
];
